import _ from 'lodash';

export default {
    methods: {
        trans(item) {
            return _.get(window.translations, item, item);
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/trans.js